import { Component, OnInit, ViewChild } from '@angular/core';
import {CheckBin} from 'src/app/_models/check-model';
import { ActivatedRoute, Router } from '@angular/router';
import { ZeroService } from 'src/app/_services/zero/zero.service';
import { REST_SERVICES } from 'src/app/_services/settings';
import { MzModalService, MzToastService, MzModalComponent } from 'ngx-materialize';
import { ModalsComponent } from 'src/app/semantic/modals/modals.component';
import {HttpClient} from '@angular/common/http';
import { Globals } from 'src/app/_services/zero/globals';
import { ToastrService } from 'ngx-toastr';
import { BinesAbcComponent } from '../bines-abc/bines-abc.component';
import { map }                from 'rxjs/operators';

declare var M: any;
@Component({
  selector: 'app-detalle-bin-sup',
  templateUrl: './detalle-bin-sup.component.html',
  styleUrls: ['./detalle-bin-sup.component.scss']
})

export class DetalleBinComponent implements OnInit {
  @ViewChild('bottomSheetModal') modal: MzModalComponent;
  @ViewChild(BinesAbcComponent) abc : BinesAbcComponent;
  instance: any;
  elems: any;
  private idBin: number;
  public rechazado: boolean;
  public aceptado: string;
  public idStatus;
  public check: Boolean = false;
  public accion: string; 
  public origen: string;
  public origenInfo: number;

  ipAddress:any;
  public checkBin : CheckBin;
  public valorRechazado:number;

  // Informacion de detalle Bin
  public dataCurrBIN;
  public idGrupo: number;
  public grupo: string;

  constructor(
    private globals: Globals,
    private _route: ActivatedRoute, 
    public _router: Router,
    private zeroService: ZeroService, 
    private modalService: MzModalService,
    private toastService: MzToastService,
    private http: HttpClient,
    private toastr: ToastrService) {
    this.checkBin = new CheckBin; 
    this.aceptado = '0';
    this.idBin = JSON.parse(this._route.snapshot.paramMap.get('idBin'));
    this.rechazado = JSON.parse(this._route.snapshot.paramMap.get('rechazado'));       
    this.grupo = this._route.snapshot.paramMap.get('grupo');
    //this.idStatus = JSON.parse(this._route.snapshot.paramMap.get('idEstatus'));

    this.valorRechazado = 0;
    if (this.rechazado) {
      this.valorRechazado = 2;
    }
    
  }

  ngOnInit() {
    // Obtencion de parametros enviados por route
    this.dataCurrBIN = this._route
    .queryParams
      .subscribe(params => {
        this.origen = params['origen'] != undefined ? params['origen'] : "";
        this.idStatus = this.origen == "BinManager" ? 1 : +params['idEstatus'] || '';
        this.check = params['checkBin'] != undefined ? JSON.parse(params['checkBin']) : false;
        this.accion = params['accion'] != undefined ? params['accion'].toUpperCase() : "";
        this.origenInfo = params['origenInfo'] != undefined ? params['origenInfo'] : 1;
        this.idGrupo = params['idGrupo'] != undefined ? params['idGrupo'] : null; 
      });
  }

  ngOnDestroy() {
    this.dataCurrBIN.unsubscribe();
  }

  expandir() {    
    this.abc.expandirCollapsables();
  }

  abrirCommentsModal() {
    if (this.valorRechazado == 2) {
      let modalComponentRef: any = this.modalService.open(ModalsComponent, {
        modal_title: "Comentario",
        modal_body: "",
        isComents: true
      });
      modalComponentRef.instance.onOkModalComment.subscribe(comentario => {
        if (comentario) {
          this.realizarCheck(comentario);
        }
    })
    } else {
      this.realizarCheck("Se reviso el check");
    }
  }

  realizarCheck(comentario:string) {
    let scope = this;
    let rechazado: boolean = this.valorRechazado == 1 ? false : true;
    scope.checkBin.id = scope.idBin;
    scope.checkBin.comentarioOpe = comentario;
    scope.checkBin.rechazar = rechazado;
    scope.checkBin.rol = localStorage.getItem('currentRol');
    if (this.grupo == "G") {
      scope.checkBin.idGrupo = scope.idBin;
    }
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.CHECK_REFUSE_BIN,
      method: "PUT", 
      showInfo: true,
      params: scope.checkBin,
      ok: (response) => {
        if (response.responsecode == "0") {
          // scope.toastService.show(
          //   '<h5>Mensaje de sistema...</h5> <span>' + response.responseMessage + '</span>',
          //   scope.globals.timeoutToast, 'blue');
            scope.toastr.success('<h5>Mensaje de sistema...</h5> <span>'+ response.responseMessage +'</span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
            scope._router.navigate(['checkSupervisor'], {
              queryParams: { refresh: new Date().getTime() }
            });
        }
      },
    });
  }

  cancela() {
    this.modal.openModal();
  }
  
  cancelarAceptar() {
    if (this.origen == "BinManager") {
      this._router.navigate(['/binmanager'], {
        queryParams: { refresh: new Date().getTime() }
      });
    } else {
      if (this.check) {      
        this._router.navigate(['/checkSupervisor'], {
          queryParams: { refresh: new Date().getTime() }
        });
      } else {      
        this._router.navigate(['/busquedaSupervisor'], {
          queryParams: { refresh: new Date().getTime() }
        });
      }
    }    
  }
}
